/**
 * @deprecated Use CheckoutRoute instead
 */
export enum HomeDeliveryRoute {
  AddressNumber = 'address-number',
  AddressComplement = 'address-complement',
  AddressStreet = 'address-street',
  AddressNeighborhood = 'address-neighborhood',
  ConfirmAddress = 'confirm-address',
  ConfirmPostalCode = 'confirm-postal-code',
}
